import { WithBorderPillsButtons } from '@quicktools/shared-components/components/core/PillsButtons';
import cls from 'classnames';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';

import { getCharacterLimitByAdWriterRadioValue } from '../../../utils/common/adWriterRadio';

import useStyles from './styles';
import { IChoices } from './types';

function Choices({ formProps, name, webLabel, mobileLabel, pills }: IChoices) {
  const { setFieldValue } = useFormikContext();

  const classes = useStyles();

  const onSelect = (value: string) => {
    setFieldValue(name, value);
  };

  useEffect(() => {
    setFieldValue(
      'characterLimit',
      getCharacterLimitByAdWriterRadioValue(formProps.values.adWriterRadioValue),
    );
  }, [formProps.values.adWriterRadioValue, setFieldValue]);

  return (
    <div className={classes.root}>
      <span className={cls(classes.label, classes.webLabel)}>{webLabel}</span>
      {mobileLabel && (
        <span className={cls(classes.label, classes.mobileLabel)}>{mobileLabel}</span>
      )}
      <WithBorderPillsButtons
        selected={formProps.values.adWriterRadioValue}
        pills={pills}
        onSelectItem={onSelect}
        orientation="row"
      />
    </div>
  );
}
export default Choices;
